<template>
    <div class="w-full">
        <div class="w-full mx-auto mt-20">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    MASTER JADWAL DOKTER - TAMBAH
                </h1>
            </div>
            <div class="w-full">
                <form @submit.prevent="store">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <SelectInput
                            v-model="form.poli"
                            :error="form.errors.poli"
                            id="poli"
                            label="poli"
                            class="w-full md:w-auto grow"
                        >
                            <option value="">=== PILIH POLI ===</option>
                            <option
                                v-for="poli in poli"
                                :key="poli.FS_KD_LAYANAN"
                                :value="poli.FS_KD_LAYANAN"
                            >
                                {{ poli.FS_NM_LAYANAN }}
                            </option>
                        </SelectInput>
                        <SelectInput
                            v-model="form.dokter"
                            :error="form.errors.dokter"
                            id="dokter"
                            label="dokter"
                            class="w-full md:w-auto md:mx-2 grow"
                        >
                            <option value="">=== PILIH DOKTER ===</option>
                            <option
                                v-for="dokter in dokterData"
                                :key="dokter.FS_KD_PEG"
                                :value="dokter.FS_KD_PEG"
                            >
                                {{ dokter.FS_NM_PEG }}
                            </option>
                        </SelectInput>
                        <SelectInput
                            v-model="form.hari"
                            :error="form.errors.hari"
                            id="hari"
                            label="hari"
                            class="w-full md:w-auto grow"
                        >
                            <option value="">=== PILIH HARI ===</option>
                            <option
                                v-for="hari in hari"
                                :key="hari.fs_kd_hari"
                                :value="hari.fs_kd_hari"
                            >
                                {{ hari.fs_nm_hari }}
                            </option>
                        </SelectInput>
                        <TimeInput
                            v-model="form.jamMulai"
                            :error="form.errors.jamMulai"
                            class="w-full mt-2"
                            id="jam_mulai"
                            label="Jam Mulai Praktik"
                            type="text"
                        />
                        <TimeInput
                            v-model="form.jamSelesai"
                            :error="form.errors.jamSelesai"
                            class="w-full mt-2"
                            id="jam_selesai"
                            label="Jam Selesai Praktik"
                            type="text"
                            :disabled="form.isSelesai"
                        />
                        <div class="mt-2">
                            <label class="form-label">Selesai</label>
                            <input type="checkbox" v-model="form.isSelesai">
                        </div>
                        <div class="mt-2 w-full text-right">
                            <p class="text-xs font-poppins">* Apabila selesai dicek maka input Jam Selesai Praktik akan disable</p>
                        </div>
                    </div>
                    <div class="w-full flex justify-center items-center">
                        <button
                            type="submit"
                            class="bg-teal-400 hover:bg-teal-700 h-16 rounded-3xl mt-8 text-white m-auto w-1/2"
                        >
                            Simpan Jadwal Dokter
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <FlashMessage class="mt-5 w-1/2 m-auto" />
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import SelectInput from "../../../Shared/SelectInput.vue";
import TimeInput from "../../../Shared/TimeInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import FlashMessage from "../../../Shared/FlashMessage.vue";
export default {
    data() {
        return {
            form: this.$inertia.form({
                poli: "",
                dokter: "",
                hari: "",
                jamMulai: "",
                jamSelesai: "",
                isSelesai: false
            }),
            dokterData: this.dokter
        };
    },
    computed: {
        formPoli(){
          return this.form.poli;  
        },
        formIsSelesai(){
            return this.form.isSelesai;
        }
    },
    watch:{
        formPoli(){
            var dokterList = [];
            const self = this;
                this.dokter.forEach(function (dokter) {
                    if(dokter.pegawai_layanan){
                        dokter.pegawai_layanan.forEach(function(layananDokter){
                            if (
                                layananDokter.FS_KD_LAYANAN ==
                                self.form.poli
                            ) {
                                dokterList.push(dokter);
                            }  
                        })
                       
                    }
                    
                });
            this.dokterData = dokterList;
        },
        formIsSelesai(){
            return (this.form.isSelesai)?this.form.jamSelesai = 'Selesai':this.form.jamSelesai = '';
        }
    },
    components: {
        Link,
        TextInput,
        FlashMessage,
        SelectInput,
        TimeInput,
    },
    props: {
        poli: Object,
        dokter: Object,
        hari: Object,
    },
    layout: LayoutAdmin,
    methods: {
        store() {
            const confirm = window.confirm(
                "Yakin menyimpan data jadwal dokter?"
            );
            if (confirm == 1) {
                this.form.post("/admin/jadwal_dokter", { preserveScroll: true });
            }
        },
    },
};
</script>
